import React, { FC } from 'react';
import { MarketingProfile, MarketingProfileById } from '../../../@types/Marketing';
import { Listbox } from './Listbox';
import { Nullable } from '../../../@types/common';

interface Props {
  profileList?: MarketingProfile[];
  selectedProfile: Nullable<MarketingProfileById>;
  onSelectProfile: (obg: MarketingProfileById) => void;
}
const ProfileSelect: FC<Props> = ({ profileList, selectedProfile, onSelectProfile }) => {
  return (
    <>
      <h2 className="mb-8 text-26 text-gray-45">Select a profile.</h2>
      <p className="text-gray-60 text-lg">Profile</p>
      <Listbox data={profileList} selectedItem={selectedProfile} onSelectedItem={onSelectProfile} />
    </>
  );
};

export default ProfileSelect;
